/**
 * Licensed Materials - Property of IBM IBM Cognos Products: BI Cloud (C)
 * Copyright IBM Corp. 2014, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'../../nls/StringResources',
	'jquery',
	'underscore',
	'../../lib/@waca/core-client/js/core-client/utils/EventHelper'
], function(View, resources, $, _) {

	var SearchBar = null;

	/**
	 * Represents a search bar that can be added to an app bar sub bar
	 */
	SearchBar = View.extend({
		events: { 'click': 'action' },
		baseClass: 'toolbar',

		/**
		 * Creates a search bar
		 *
		 * @param view -
		 *            The list view to which the search bar will execute search on.
		 */
		init: function(spec) {
			_.extend(this, spec);
			SearchBar.inherited('init', this, arguments);
			this.$input = $('<input type="search" class="searchbar" placeholder="' + resources.get('searchHint') + '">');
			var _self = this;
			this.$input.on('search', function () {
				_self.execSearch();
			});
			this.$input.on('click', function () {
				// 'this' is the jquery object instance, we don't want to bind(this)
				this.setSelectionRange(0, 9999);
			});
			this.$input.keyup(function(e) {
				if (e.which === 13) {
					_self.execSearch();
					_self.$input.blur();
					e.preventDefault();
				} else {
					_self.showHideClearSearchButton();
				}
			});
			this.$searchButton = $('<button type="button" title="' + resources.get('search') + '" class="search"><span class="wfg_search"></span></button>');
			this.$searchButton.click(function(){
				_self.execSearch();
			});
			this.$clearSearchButton = $('<button  type="reset" title="' + resources.get('clearSearchResult') + '" class="reset"><span class="wfg_close"></span></button>');
			this.$clearSearchButton.click(function(){
				_self.$input.val('');
				_self.execSearch();
				_self.showHideClearSearchButton();
			});
			this.$clearSearchButton.css('visibility', 'hidden');

			this.$input.on('change', this.showHideClearSearchButton.bind(this));
		},

		/**
		 * Draws the Search bar
		 */
		render: function() {
			this.$el.empty();
			var $form = $('<div class="searchbar">');
			$form.append(this.$input);
			$form.append(this.$clearSearchButton);
			$form.append(this.$searchButton);

			$form.appendTo(this.$el);
			return this;
		},

		show: function(noFocus) {
			if (this.$el.is(':hidden')) {
				this.$input.fadeIn('fast');
				this.$searchButton.fadeIn('fast');
				this.$clearSearchButton.fadeIn('fast');
				this.$el.slideDown('fast');
				if (!noFocus) {
					this.$input.focus();
					this.$input.select();
				}
			}
		},

		clear: function() {
			this.$input.val('');
		},

		setSearchString: function(searchString) {
			var str = searchString?decodeURIComponent(searchString):'';
			if (this.$input.val() !== str) {
				this.$input.val(str);
			}
		},

		hide: function(preserveInput) {
			if (!this.$el.is(':hidden')) {
				this.$el.slideUp('fast');
				this.$input.fadeOut('fast');
				if (!preserveInput) {
					this.$input.val('');
				}
				this.$input.blur();
				this.$searchButton.fadeOut('fast');
				this.$clearSearchButton.fadeOut('fast');
			}
		},

		isHidden: function() {
			return this.$el.is(':hidden');
		},

		execSearch: function() {
			var trimInput = $.trim(this.$input.val());
			if(trimInput === '') {
				trimInput = null;
			} else {
				trimInput = encodeURIComponent(trimInput);
			}
			this.view.setSearchString(trimInput);
		},

		showHideClearSearchButton: function() {
			this.$clearSearchButton.css('visibility', (this.$input.val().length > 0) ? 'visible' : 'hidden');
		}
	});

	return SearchBar;
});
